import api from "./axios";

// Personal todos for staff. Admins may pass { employee_id } to list/assign for
// an employee; everyone else operates on their own list.
export const listTodos = (params = {}) => api.get("/todos", { params });
export const createTodo = (payload) => api.post("/todos", payload);
export const updateTodo = (id, payload) => api.patch(`/todos/${id}`, payload);
export const deleteTodo = (id) => api.delete(`/todos/${id}`);
